<template>
  <section id="headerToolbar">
    <User />
  </section>
</template>
<script>
import { mapMutations } from 'vuex'
import User from './User.vue'
export default {
  name: 'HeaderToolbar',
  components: {
    User
  },
  methods: {
    ...mapMutations('layout', ['setIsShowSetting'])
  }
}
</script>
<style lang="scss" scoped>
#headerToolbar {
  margin-right: 60px;
  display: flex;
  align-items: center;
  .setting {
    color: #fff;
    cursor: pointer;
  }
}
</style>
